/**
 * DELEGATE — the static source-catalogue read moved to `@heidi/evidence` at the
 * chat-inversion slice. `GET /chat/sources` still returns the same catalogue and
 * the request is unchanged (the `@heidi/api/client` registry hands back the same
 * `scribeHttpV2` instance the old module imported directly).
 *
 * BODIED FOR ONE TERM. The pre-move hook read no token, consulted no flag and
 * fired no toast, so for a while this file was a pure re-export. What it
 * resolves now is the SURFACE: `GET /v2/chat/sources` stays in ml-scribe's
 * cloud-only chat router — the catalogue is a list of web domains and an
 * appliance has no web search — so on an on-prem build the route does not
 * exist and the read is disabled at the source. A package `/data` hook may not
 * read the build profile (F5), so the term crosses here as one boolean, and
 * `src/utils/backendSurfaces.guard.test.ts` keeps this file the hook's only
 * importer.
 *
 * The signature is unchanged (no arguments), so no call site moves, and the
 * path stays so that all four app-side importers and every `jest.mock` literal
 * aimed at this module keep resolving.
 *
 * `GET_SOURCES` and `ChatSourceItem` are DECLARED in `@heidi/evidence/contracts`
 * and re-exported here name-intact. Never re-declare either.
 */
import { isChatSourcesApiAvailable } from '@/utils/backendSurfaces';
import { useQuerySources as useQuerySourcesCore } from '@heidi/evidence/data';

export { GET_SOURCES } from '@heidi/evidence/contracts';
export type { ChatSourceItem } from '@heidi/evidence/contracts';

export function useQuerySources() {
  return useQuerySourcesCore({ enabled: isChatSourcesApiAvailable });
}
